// Lets the server colour index.html's shell (web/shell_theme.go), since the CSP
// allows no inline script to read storage.
const COOKIE = "kn_color_mode";

// A year, so an infrequent visitor doesn't get the white flash back.
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export function rememberColorMode(isDark: boolean): void {
  if (typeof document === "undefined") return;

  const secure = typeof location !== "undefined" && location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE}=${isDark ? "dark" : "light"}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}
